import React, { useState, createContext } from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"
import Background3D from "../components/3d/background3d"
import { TypedJS } from "../components/TypedJS"
import About from "../components/About"
import Projects from "../components/Projects"
import ContactMe from "../components/ContactMe"
import SkillsExperience from "../components/SkillsExperience"
import Loading from "../components/Loading"

export const GlobalContext = createContext({
  updateModelData: () => {},
  backgroundStatus: {
    status: "loading",
    totalItems: 3,
    itemsLoaded: 0,
  },
})

const instanceKey = Math.random()

const IndexPage = () => {
  const [backgroundStatus, updateStatus] = useState({
    status: "loading",
    totalItems: 3,
    itemsLoaded: 0,
  })
  const [showModel, toggleModel] = useState(false)
  const [modelData, updateModelData] = useState()
  return (
    <GlobalContext.Provider value={{ updateModelData, backgroundStatus }}>
      <Layout>
        <SEO />
        <Background3D
          // {...dimensions}
          updateStatus={updateStatus}
          backgroundStatus={backgroundStatus}
          showModel={showModel}
        />
        <TypedJS
          startAnimation={backgroundStatus.status === "success"}
          key={instanceKey}
          toggleModel={toggleModel}
        />
        <About />
        <SkillsExperience />
        <Projects />
        <ContactMe
          modelData={modelData}
          showModel={backgroundStatus.status === "success"}
        />
        {backgroundStatus.status === "loading" && <Loading />}
      </Layout>
    </GlobalContext.Provider>
  )
}

export default IndexPage
